import { useLocation, useNavigate } from "react-router-dom";
import { BRAND, NAV_LINKS } from "../data/site";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const handleLink = (id) => {
    const link = NAV_LINKS.find((l) => l.id === id);
    if (link?.route) {
      navigate(link.route);
      return;
    }
    if (id === "menu") {
      navigate("/menu");
      return;
    }
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="bg-cocoa text-[#FAF3E7] pt-20 pb-10 grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logoTransparent}
                alt="Andhra Biryani Co"
                className="h-14 w-14 rounded-full ring-1 ring-[#C8A14B]/60 bg-[#2a130a]"
              />
              <div>
                <div className="font-display text-xl">{BRAND.name}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4A24E]">
                  Andhra Style · Authentic Taste
                </div>
              </div>
            </div>
            <p className="mt-6 text-[#FAF3E7]/70 text-sm max-w-md leading-relaxed">
              Slow-cooked Andhra biryani made the old way — handi, dum and a
              stubborn refusal to soften the heat.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4A24E] font-semibold">
              Explore
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => handleLink(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-[#FAF3E7]/80 hover:text-[#D4A24E] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4A24E] font-semibold">
              Hours
            </div>
            <ul className="mt-4 space-y-2.5 text-sm text-[#FAF3E7]/80">
              <li>Mon – Thu &nbsp;·&nbsp; 12:00 PM – 11:00 PM</li>
              <li>Fri – Sun &nbsp;·&nbsp; 11:30 AM – 11:30 PM</li>
              <li className="pt-3 border-t border-[#FAF3E7]/10 mt-3">
                Mail Us:{" "}
                <a
                  href="mailto:help@andhrabiryani.co"
                  className="text-[#D4A24E] hover:underline"
                  data-testid="footer-catering-email"
                >
                  help@andhrabiryani.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#FAF3E7]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#FAF3E7]/60">
          <div>© {new Date().getFullYear()} Andhra Biryani Co. All rights reserved.</div>
          <div className="font-display italic text-[#D4A24E]">
            &ldquo;॥ Annam Parabrahma Swaroopam ॥&rdquo;
          </div>
        </div>
      </div>
    </footer>
  );
}
